import { updateTimer } from '../../actions/actions';

export const videoStateSliceOptions = {
	name: 'player state',
	initialState: null,
	reducers: {
		setState(state, action) {
			return action.payload.video_state;
		}
	},
	extraReducers: {
		[updateTimer](state, action) {
			return action.payload.video_state ?? state;
		}
	}
};
